import SearchProduct from '../schema/SearchProduct';

import searchApi from '../../api/search';
import { SEARCH_PRODUCTS as searchProductsTypes } from '../mutation-types';

// Actions
const actions = {
  fetch({
    commit
  }, payload) {
    return new Promise(function(resolve, reject) {
      return searchApi.searchProducts(payload, function(err, res) {
        if (err) {
          return reject(err);
        }
        commit(searchProductsTypes.DATA_RECEIVED, res);
        resolve(res);
      });
    });
  },

  addToWishlist({
    commit
  }, payload) {
    return new Promise(function(resolve) {
      commit(searchProductsTypes.ADDED_TO_WISHLIST, payload);
      resolve();
    });
  },

  /*
  直近カートに入れた商品リストカスタムAPI
  */
  previouslyInCart({
    commit
  }, payload) {
    return new Promise(function(resolve, reject) {
      return searchApi.previouslyInCart(payload, function(err, res) {
        if (err) {
          return reject(err);
        }
        commit(searchProductsTypes.DATA_RECEIVED, res);
        resolve(res);
      });
    });
  },

  recentlyViewedItems({
    commit
  }, payload) {
    return new Promise(function(resolve, reject) {
      return searchApi.recentlyViewedItems(payload, function(err, res) {
        if (err) {
          return reject(err);
        }
        commit(searchProductsTypes.DATA_RECEIVED, res);
        resolve(res);
      });
    });
  },

  artcleRelatedItemsOrRankingItems({
    commit
  }, payload) {
    return new Promise(function(resolve, reject) {
      return searchApi.artcleRelatedItemsOrRankingItems(payload, function(err, res) {
        if (err) {
          return reject(err);
        }
        commit(searchProductsTypes.DATA_RECEIVED, res);
        resolve(res);
      });
    });
  },

  clear({
    commit
  }, payload) {
    commit(searchProductsTypes.CLEAR, payload);
  }
};

// `fetch` のエイリアス
actions.search = actions.fetch;

const mutations = {
  [searchProductsTypes.DATA_RECEIVED](state, payload) {
    payload.products.map((product) =>
      SearchProduct.update({
        _id: product._id
      }, product, {
        upsert: true
      })
    );
  },

  [searchProductsTypes.ADDED_TO_WISHLIST](state, payload) {
    SearchProduct.updateById(payload.product_id, {
      is_added_to_wishlist: payload.is_added_to_wishlist
    });
  },

  [searchProductsTypes.CLEAR](state, payload) {
    let where = {};
    if (payload.excludingIds) {
      where = (p) => !payload.excludingIds.includes(p._id);
    }
    SearchProduct.remove(where);
  }
};

export default {
  namespaced: true,
  state: SearchProduct.state,
  getters: SearchProduct.getters,
  actions,
  mutations
};
